import * as React from 'react';
import * as styles from './styles.css';
import { CloseButton } from '../CloseButton';

export interface IFullscreenGalleryHeaderProps {
  onClose(): void;
  favorite: React.ReactNode;
  tabs: React.ReactNode;
  call: React.ReactNode;
}

export function Header({ onClose, favorite, tabs, call }: IFullscreenGalleryHeaderProps) {
  return (
    <div className={styles['container']} data-testid="FullscreenGalleryHeader">
      <div className={styles['menu']}>{tabs}</div>
      <div className={styles['aside']}>
        {call}
        {favorite}
        <div className={styles['close']}>
          <CloseButton onClick={onClose} />
        </div>
      </div>
    </div>
  );
}
